import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";

import { updateAgency } from "common/services/agencies.service";
import VehicleModelForm from "./AgencyForm";

const UpdateVehicleModel: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  selectedRecord: {
    id: number;
    name: string;
    category: {
      id: number;
      name: string;
    };
  };
  fetchAgencies: () => void;
}> = ({ toggle, isModalOpen, selectedRecord, fetchAgencies }) => {
  const [loading, setLoading] = useState<boolean>(false);
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: selectedRecord?.name || "",
      category: selectedRecord?.category?.id || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Make"),
      category: Yup.string(),
    }),
    onSubmit: async (values) => {
      const updatedData = {
        id: selectedRecord.id,
        data: {
          name: values["name"],
          category: values["category"],
        },
      };

      setLoading(true);
      try {
        await updateAgency(updatedData);
        fetchAgencies();
        validation.resetForm();
        toggle();
        toast.success("Agency updated successfully", {});
      } catch (error) {
        toast.error("Agency update failed", {});
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal id="showModal" isOpen={isModalOpen} toggle={toggle} centered>
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Update Agency
      </ModalHeader>

      <VehicleModelForm
        validation={validation}
        isUpdate={true}
        loading={loading}
        toggle={toggle}
      />
    </Modal>
  );
};

export default UpdateVehicleModel;
